// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/paragraph/ParagraphLogoStripGroup.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/paragraph/ParagraphLogoStripGroup.tsx");
  import.meta.hot.lastModified = "1732036225886.598";
}
// REMIX HMR END

import { default as ParagraphLogoStripComponent } from "./ParagraphLogoStrip";
import { generate } from "randomstring";
import Heading from "../Heading";
export default function LogoStripGroup({
  items,
  textOptional,
  title
}) {
  return <div className="flex flex-col justify-center gap-4 text-neutral-100">
      <Heading tag="h2" className="text-center !text-neutral-100">{title}</Heading>
      <div className="text-center" dangerouslySetInnerHTML={{
      __html: textOptional?.processed || ""
    }} />
      <ul className="flex flex-col justify-center gap-8">
        {items?.map(item => <ParagraphLogoStripComponent key={generate({
        length: 5,
        charset: "alphanumeric"
      })} title={item.title} items={item.items} />)}
      </ul>
    </div>;
}
_c = LogoStripGroup;
var _c;
$RefreshReg$(_c, "LogoStripGroup");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;